import { useState, useEffect, useRef } from "react";

/* ─── CSS ─────────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
*{box-sizing:border-box;margin:0;padding:0}
:root{
  --bg:#0a0e1a;--bg2:#111827;--gb:rgba(255,255,255,.05);
  --acc:#2962FF;--acc2:#22c55e;
  --red:#ef4444;--green:#22c55e;--amber:#eab308;--orange:#f97316;--purple:#7c3aed;--cyan:#2962FF;
  --text:#d1d5db;--muted:#9ca3af;--dim:#6b7280;--r:10px;
}
body{font-family:'Inter',system-ui,sans-serif;background:var(--bg);color:var(--text);min-height:100vh;overflow-x:hidden}
.mesh{position:fixed;inset:0;z-index:0;pointer-events:none;
  background:var(--bg);
  background-image:radial-gradient(ellipse at 15% 50%,rgba(41,98,255,.05) 0%,transparent 50%),
    radial-gradient(ellipse at 85% 20%,rgba(34,197,94,.03) 0%,transparent 50%)}

/* signup */
.sp{position:relative;z-index:2;min-height:100vh;display:flex;align-items:center;justify-content:center;padding:40px 24px}
.sc{background:var(--bg2);border-radius:16px;padding:44px 48px;max-width:540px;width:100%;
  border:1px solid rgba(255,255,255,.06);box-shadow:0 4px 24px rgba(0,0,0,.3)}
.sc h1{font-size:1.8rem;font-weight:700;color:#fff;margin-bottom:4px;text-align:center;letter-spacing:-.03em}
.sub{color:var(--muted);font-size:.85rem;text-align:center;margin-bottom:28px;line-height:1.6}
.logo{text-align:center;margin-bottom:16px;font-size:1.4rem;font-weight:800;letter-spacing:.05em;color:var(--acc)}
.logo span{color:var(--acc2)}
.fg{margin-bottom:18px}
.fg label{display:block;font-size:.72rem;color:var(--muted);font-weight:600;margin-bottom:6px;text-transform:uppercase;letter-spacing:1px}
.fg input,.fg select{width:100%;padding:13px 16px;border-radius:10px;border:1px solid var(--gb);
  background:rgba(0,0,0,.3);color:var(--text);font-size:.92rem;font-family:inherit;
  transition:border-color .3s,box-shadow .3s;outline:none}
.fg input:focus,.fg select:focus{border-color:var(--acc);box-shadow:0 0 0 3px rgba(41,98,255,.08)}
.fg select option{background:var(--bg2);color:var(--text)}
.ferr{color:var(--red);font-size:.75rem;margin-top:4px}
.sbtn{width:100%;padding:14px;border:none;border-radius:8px;font-size:1rem;font-weight:600;
  background:var(--acc);color:#fff;cursor:pointer;transition:background .2s;margin-top:8px;font-family:inherit}
.sbtn:hover{background:#1a4fd4}
.sinfo{display:flex;gap:16px;margin-top:24px;padding-top:20px;border-top:1px solid var(--gb)}
.sinfo>div{flex:1;text-align:center}
.sin{font-size:1.4rem;font-weight:700;color:#fff}
.sil{font-size:.66rem;color:var(--muted);text-transform:uppercase;letter-spacing:.5px;margin-top:3px}

/* training */
.tp{position:relative;z-index:2;min-height:100vh;display:flex;flex-direction:column}
.tbar{position:sticky;top:0;z-index:30;background:rgba(10,14,26,.92);backdrop-filter:blur(10px);
  border-bottom:1px solid rgba(255,255,255,.05);padding:0 24px;height:52px;display:flex;align-items:center;gap:16px}
.tbar .sl{font-size:.7rem;color:#fff;text-transform:uppercase;letter-spacing:1px;font-weight:600;min-width:140px;opacity:.7;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pt{flex:1;height:3px;background:rgba(255,255,255,.06);border-radius:3px;overflow:hidden}
.pf{height:100%;background:var(--acc);border-radius:3px;transition:width .5s ease}
.pb{background:rgba(41,98,255,.08);border:1px solid rgba(41,98,255,.12);border-radius:6px;
  padding:4px 12px;font-size:.74rem;color:var(--acc);font-weight:600;white-space:nowrap}
.sec{padding:40px 24px 100px;max-width:860px;margin:0 auto;width:100%;animation:fu .5s ease both}
@keyframes fu{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
.snum{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;
  border-radius:8px;background:var(--acc);color:#fff;font-size:.78rem;font-weight:700;margin-bottom:8px}
.sec h2{font-size:clamp(1.4rem,3vw,2rem);font-weight:700;color:#fff;margin-bottom:6px;letter-spacing:-.02em}
.sec h3{font-size:1.05rem;color:#fff;margin:16px 0 8px;font-weight:600}
.sec p,.sec li{font-size:.9rem;line-height:1.75;color:var(--text)}
.lead{color:var(--muted);max-width:600px;margin-bottom:20px;font-size:.9rem;line-height:1.7}
.hl{color:var(--acc);font-weight:600}.dg{color:var(--red);font-weight:600}

/* cards */
.gc{background:var(--bg2);border:1px solid rgba(255,255,255,.05);border-radius:var(--r);padding:22px 24px;transition:border-color .2s}
.gc:hover{border-color:rgba(255,255,255,.1)}
.gc.red{border-left:4px solid var(--red)}.gc.green{border-left:4px solid var(--green)}
.gc.amber{border-left:4px solid var(--amber)}.gc.orange{border-left:4px solid var(--orange)}
.gc.purple{border-left:4px solid var(--purple)}.gc.cyan{border-left:4px solid var(--cyan)}
.cg{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:14px;margin:14px 0}
.ct{font-size:.95rem;font-weight:600;color:#fff;margin-bottom:6px;display:flex;align-items:center;gap:8px}
.gc>p{font-size:.84rem;color:var(--muted);margin-top:4px;line-height:1.6}
.gc ul{list-style:none;margin-top:6px}
.gc ul li{padding:4px 0 4px 18px;position:relative;font-size:.84rem;color:var(--text)}
.gc ul li::before{content:'';position:absolute;left:0;top:12px;width:4px;height:4px;
  border-radius:50%;background:var(--muted);opacity:.5}
.gc.red ul li::before{background:var(--red)}.gc.green ul li::before{background:var(--green)}

/* stats */
.sr{display:flex;gap:14px;flex-wrap:wrap;justify-content:center;margin:18px 0}
.sb{background:var(--bg2);border:1px solid rgba(255,255,255,.05);border-radius:var(--r);
  padding:20px 24px;text-align:center;min-width:140px;flex:1}
.sbn{font-size:1.8rem;font-weight:700;color:var(--acc)}
.sbn.red{color:var(--red)}.sbn.amber{color:var(--amber)}
.sbl{font-size:.7rem;color:var(--muted);margin-top:3px;line-height:1.4;text-transform:uppercase;letter-spacing:.3px}

/* steps */
.steps{display:flex;align-items:flex-start;margin:20px 0;justify-content:center;flex-wrap:wrap}
.step{display:flex;flex-direction:column;align-items:center;text-align:center;flex:1;
  min-width:90px;max-width:155px;position:relative;padding:0 6px}
.si{width:48px;height:48px;border-radius:12px;background:var(--bg2);border:1px solid rgba(255,255,255,.08);
  display:flex;align-items:center;justify-content:center;font-size:1.2rem;margin-bottom:8px;position:relative;z-index:2}
.sl2{position:absolute;top:24px;left:calc(50% + 28px);width:calc(100% - 56px);height:1px;
  background:rgba(255,255,255,.08);z-index:1}
.step:last-child .sl2{display:none}
.sti{font-size:.74rem;font-weight:600;color:#fff;margin-bottom:2px}
.std{font-size:.66rem;color:var(--muted);line-height:1.3}

/* case */
.cb{background:var(--bg2);border:1px solid rgba(239,68,68,.08);border-radius:var(--r);padding:28px;margin:14px 0}
.ctag{display:inline-block;background:linear-gradient(135deg,#dc2626,var(--red));color:#fff;
  padding:3px 12px;border-radius:20px;font-size:.64rem;text-transform:uppercase;letter-spacing:1.5px;font-weight:600;margin-bottom:10px}
.cb h3{color:#fff;font-size:1.1rem;margin-bottom:4px}
.cmeta{font-size:.74rem;color:var(--muted);margin-bottom:12px;display:flex;gap:16px;flex-wrap:wrap}
.cl{background:rgba(16,185,129,.04);border:1px solid rgba(16,185,129,.12);border-radius:11px;padding:14px 18px;margin-top:14px}
.cl strong{color:var(--green);font-size:.84rem}
.cl p{font-size:.82rem;margin:3px 0 0;line-height:1.6}

/* takeaway */
.tw{background:rgba(41,98,255,.03);border:1px solid rgba(41,98,255,.08);border-radius:var(--r);
  padding:16px 22px;margin:16px 0;font-size:.85rem;line-height:1.7}
.tw strong{color:#fff}

/* email mock */
.em{background:var(--bg2);border-radius:var(--r);max-width:640px;width:100%;
  border:1px solid var(--gb);margin:14px auto;box-shadow:0 8px 30px rgba(0,0,0,.25)}
.ech{background:rgba(0,0,0,.3);padding:10px 14px;display:flex;align-items:center;gap:7px;
  border-bottom:1px solid var(--gb);border-radius:var(--r) var(--r) 0 0}
.dot{width:9px;height:9px;border-radius:50%}
.eh{background:rgba(0,0,0,.15);padding:14px 18px;border-bottom:1px solid var(--gb)}
.ehr{display:flex;align-items:flex-start;gap:8px;margin-bottom:5px;font-size:.82rem;line-height:1.5}
.ehl{color:var(--muted);min-width:52px;flex-shrink:0;font-weight:500}
.ehv{color:var(--text);flex:1}.ehv.bad{color:var(--red)}
.eb{padding:18px 20px;font-size:.86rem;line-height:1.75}
.furl{color:var(--red);text-decoration:underline;cursor:default;word-break:break-all}

/* red flags */
.rfz{display:inline-block;position:relative;cursor:pointer;vertical-align:middle;z-index:5}
.rfb{display:inline-flex;align-items:center;gap:3px;background:rgba(239,68,68,.08);
  border:1px solid rgba(239,68,68,.2);border-radius:5px;padding:2px 8px;font-size:.64rem;
  color:var(--red);font-weight:600;margin:0 3px;animation:rfp 2.5s ease-in-out infinite;transition:all .3s;cursor:pointer}
@keyframes rfp{0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,.12)}50%{box-shadow:0 0 0 4px rgba(239,68,68,.04)}}
.rfb.found{background:rgba(16,185,129,.1);border-color:rgba(16,185,129,.25);color:var(--green);animation:none}
.rft{display:none;position:absolute;top:calc(100% + 10px);left:50%;transform:translateX(-50%);
  background:linear-gradient(135deg,#dc2626,var(--red));color:#fff;padding:11px 15px;
  border-radius:10px;font-size:.78rem;width:250px;text-align:center;z-index:100;line-height:1.55;
  box-shadow:0 8px 28px rgba(239,68,68,.25)}
.rft::before{content:'';position:absolute;bottom:100%;left:50%;transform:translateX(-50%);
  border:6px solid transparent;border-bottom-color:var(--red)}
.rfz:hover .rft,.rfb.found+.rft{display:block}
.rfb.found+.rft{background:linear-gradient(135deg,#059669,var(--green))}
.rfb.found+.rft::before{border-bottom-color:var(--green)}

/* phone */
.pm{background:var(--bg2);border-radius:24px;max-width:300px;width:100%;overflow:hidden;
  border:3px solid #334155;margin:10px auto;box-shadow:0 8px 30px rgba(0,0,0,.3)}
.pn{height:28px;background:#000;display:flex;align-items:center;justify-content:center}
.pn::after{content:'';width:80px;height:6px;border-radius:3px;background:#1e293b}
.pb2{padding:14px 16px;min-height:180px}
.pl{font-size:.66rem;color:var(--muted);text-align:center;margin-top:6px;text-transform:uppercase;letter-spacing:1px}
.wam{background:#005c4b;border-radius:8px 8px 8px 0;padding:10px 12px;margin:6px 0;font-size:.82rem;line-height:1.5;color:#e5e5e5;max-width:92%}
.wan{color:#25d366;font-size:.72rem;font-weight:600;margin-bottom:2px}
.wat{font-size:.62rem;color:rgba(255,255,255,.4);text-align:right;margin-top:3px}
.wao{background:#1f2c34;border-radius:8px 8px 0 8px;margin-left:auto}
.sms{background:rgba(17,24,39,.85);border:1px solid var(--gb);border-radius:12px;padding:14px 16px;margin:6px 0;font-size:.82rem;line-height:1.6}

/* scenario */
.scbox{background:var(--bg2);border:1px solid rgba(255,255,255,.05);border-radius:var(--r);padding:24px;margin:16px 0}
.scq{font-size:.92rem;line-height:1.7;margin-bottom:14px;color:#fff}
.sccs{display:flex;flex-direction:column;gap:8px}
.scc{background:rgba(255,255,255,.02);border:1px solid var(--gb);border-radius:10px;
  padding:12px 16px;cursor:pointer;transition:all .25s;font-size:.85rem;line-height:1.5}
.scc:hover:not(.dis){background:rgba(41,98,255,.04);border-color:rgba(41,98,255,.15)}
.scc.cor{background:rgba(16,185,129,.08);border-color:var(--green);color:#fff}
.scc.wrg{background:rgba(239,68,68,.06);border-color:var(--red);color:var(--muted)}
.scc.dis{pointer-events:none}
.scf{margin-top:12px;padding:12px 16px;border-radius:10px;font-size:.82rem;line-height:1.6}
.scf.ok{background:rgba(16,185,129,.06);border:1px solid rgba(16,185,129,.12);color:var(--green)}
.scf.no{background:rgba(239,68,68,.05);border:1px solid rgba(239,68,68,.1);color:var(--red)}

/* checklist */
.cl2{max-width:600px;width:100%;margin:12px 0}
.ci{display:flex;align-items:flex-start;gap:12px;padding:12px 16px;background:var(--bg2);
  border-radius:10px;margin-bottom:7px;cursor:pointer;border:1px solid rgba(255,255,255,.05);transition:all .3s}
.ci:hover:not(.ck){border-color:rgba(41,98,255,.15)}
.ci.ck{border-color:rgba(16,185,129,.25);background:rgba(16,185,129,.03)}
.cb2{width:22px;height:22px;border-radius:6px;border:2px solid var(--dim);flex-shrink:0;
  display:flex;align-items:center;justify-content:center;transition:all .3s;margin-top:2px}
.ci.ck .cb2{background:var(--green);border-color:var(--green)}
.cit h4{font-size:.86rem;color:#fff;margin-bottom:1px;font-weight:600}
.cit p{font-size:.74rem;color:var(--muted);line-height:1.4}

/* stp */
.stpc{text-align:center;margin:10px 0;font-size:.85rem;color:var(--muted)}
.stpc span{color:var(--acc);font-weight:700}
.stpr{margin-top:14px;padding:16px 20px;border-radius:var(--r);text-align:center;font-size:.88rem}
.stpr.gr{background:rgba(16,185,129,.06);border:1px solid rgba(16,185,129,.12);color:var(--green)}
.stpr.ok2{background:rgba(249,115,22,.06);border:1px solid rgba(249,115,22,.12);color:var(--orange)}

/* mini-q */
.mq{background:var(--bg2);border:1px solid rgba(255,255,255,.05);border-radius:var(--r);padding:20px 24px;margin:20px 0}
.mql{font-size:.66rem;color:var(--acc);text-transform:uppercase;letter-spacing:1.5px;font-weight:600;margin-bottom:6px}
.mq h4{color:#fff;font-size:.92rem;margin-bottom:10px;font-weight:500;line-height:1.5}
.mqo2{display:flex;flex-direction:column;gap:6px}
.mqopt{background:rgba(255,255,255,.02);border:1px solid var(--gb);border-radius:8px;
  padding:10px 14px;cursor:pointer;transition:all .25s;font-size:.84rem}
.mqopt:hover:not(.dis){background:rgba(41,98,255,.04);border-color:rgba(41,98,255,.15)}
.mqopt.cor{background:rgba(16,185,129,.1);border-color:var(--green);color:#fff}
.mqopt.wrg{background:rgba(239,68,68,.06);border-color:var(--red);color:var(--muted)}
.mqopt.dis{pointer-events:none}
.mqfb{margin-top:8px;padding:8px 12px;border-radius:8px;font-size:.8rem;line-height:1.5}
.mqfb.ok{background:rgba(16,185,129,.06);color:var(--green)}
.mqfb.no{background:rgba(239,68,68,.04);color:var(--red)}

/* quiz */
.qw{max-width:680px;width:100%;margin:0 auto}
.qq{background:var(--bg2);border:1px solid rgba(255,255,255,.05);border-radius:var(--r);padding:24px;margin-bottom:14px}
.qn{color:var(--acc);font-size:.66rem;text-transform:uppercase;letter-spacing:2px;margin-bottom:6px;display:block;font-weight:600}
.qsc{font-size:.82rem;color:var(--muted);line-height:1.6;margin-bottom:10px;padding:10px 14px;
  background:rgba(0,0,0,.2);border-radius:8px;border-left:3px solid var(--acc)}
.qq h3{color:#fff;font-size:.94rem;margin-bottom:12px;font-weight:500;line-height:1.5}
.qo{display:flex;flex-direction:column;gap:7px}
.qopt{background:rgba(255,255,255,.02);border:1px solid rgba(255,255,255,.05);border-radius:9px;
  padding:11px 14px;cursor:pointer;transition:all .25s;font-size:.84rem;line-height:1.4}
.qopt:hover:not(.dis){background:rgba(41,98,255,.04);border-color:rgba(41,98,255,.15)}
.qopt.sel{background:rgba(41,98,255,.08);border-color:var(--acc)}
.qopt.cor{background:rgba(16,185,129,.1);border-color:var(--green);color:#fff}
.qopt.wrg{background:rgba(239,68,68,.06);border-color:var(--red);color:var(--muted)}
.qopt.dis{pointer-events:none}
.qfb{margin-top:10px;padding:10px 14px;border-radius:9px;font-size:.82rem;line-height:1.6}
.qfb.ok{background:rgba(16,185,129,.06);color:var(--green);border:1px solid rgba(16,185,129,.1)}
.qfb.no{background:rgba(239,68,68,.04);color:var(--red);border:1px solid rgba(239,68,68,.08)}
.qnav{display:flex;justify-content:flex-end;margin-top:16px;gap:10px}

/* compare */
.cgrid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin:16px 0}
@media(max-width:700px){.cgrid{grid-template-columns:1fr}}
.cpanel{position:relative}
.clbl{display:inline-block;padding:3px 14px;border-radius:20px;font-size:.66rem;
  font-weight:700;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:8px}
.clbl.real{background:linear-gradient(135deg,#059669,var(--green));color:#fff}
.clbl.fake{background:linear-gradient(135deg,#dc2626,var(--red));color:#fff}
.dz{cursor:pointer;transition:all .3s;border-radius:3px;padding:0 2px;display:inline}
.dz:hover{background:rgba(249,115,22,.15)}
.dz.found{background:rgba(16,185,129,.12);outline:1px dashed var(--green)}
.cex{margin-top:8px;padding:10px 14px;border-radius:10px;font-size:.8rem;line-height:1.5;
  background:rgba(41,98,255,.04);border:1px solid rgba(41,98,255,.08);color:var(--text)}
.cctr{text-align:center;margin:10px 0;font-size:.85rem;color:var(--muted)}
.cctr span{color:var(--acc);font-weight:700}

/* timeline */
.tl{position:relative;max-width:700px;margin:16px auto;padding-left:28px}
.tl::before{content:'';position:absolute;left:11px;top:0;bottom:0;width:1px;background:rgba(255,255,255,.08)}
.tli{position:relative;margin-bottom:18px;padding-left:24px}
.tld{position:absolute;left:-22px;top:4px;width:10px;height:10px;border-radius:50%;border:2px solid var(--acc);background:var(--bg)}
.tly{font-size:.72rem;color:var(--acc);font-weight:700;text-transform:uppercase;letter-spacing:1px}
.tlt{font-size:.88rem;color:#fff;font-weight:600;margin:2px 0}
.tldc{font-size:.78rem;color:var(--muted);line-height:1.5}

/* buttons */
.btn{padding:11px 24px;border-radius:10px;font-size:.85rem;font-weight:600;cursor:pointer;
  transition:all .2s;border:none;font-family:inherit}
.btn.p{background:var(--acc);color:#fff}
.btn.p:hover{background:#1a4fd4}
.btn.p:disabled{opacity:.35;cursor:not-allowed}
.btn.s{background:rgba(41,98,255,.06);color:var(--acc);border:1px solid rgba(41,98,255,.12)}
.btn.s:hover{background:rgba(41,98,255,.12)}
.btn.g{background:transparent;color:var(--muted);border:1px solid var(--gb)}
.btn.g:hover{color:var(--text);border-color:rgba(255,255,255,.12)}

/* bottom nav */
.bn{position:fixed;bottom:0;left:0;right:0;height:60px;z-index:30;
  background:rgba(10,14,26,.92);backdrop-filter:blur(10px);
  border-top:1px solid rgba(255,255,255,.05);
  display:flex;align-items:center;justify-content:space-between;padding:0 24px}
.bi{font-size:.72rem;color:var(--muted)}

/* cert */
.certp{position:relative;z-index:2;min-height:100vh;display:flex;align-items:center;justify-content:center;padding:40px 24px}
.certc{background:var(--bg2);border-radius:16px;padding:40px 48px;max-width:560px;width:100%;
  border:1px solid rgba(255,255,255,.06);text-align:center;box-shadow:0 4px 24px rgba(0,0,0,.3)}
.certb{width:90px;height:90px;border-radius:50%;border:3px solid var(--acc);
  display:flex;align-items:center;justify-content:center;margin:0 auto 16px;font-size:2.6rem;background:var(--bg)}
.certc h2{color:#fff;font-size:1.5rem;margin-bottom:4px}
.certn{font-size:1.6rem;font-weight:700;color:var(--acc);margin:10px 0 4px}
.certd{font-size:.82rem;color:var(--muted);margin-bottom:16px}
.certst{display:flex;justify-content:center;gap:28px;margin:16px 0}
.certst>div{text-align:center}
.certsn{font-size:1.6rem;font-weight:700}
.certsl{font-size:.66rem;color:var(--muted);text-transform:uppercase;letter-spacing:.5px}
.certa{display:flex;gap:10px;justify-content:center;margin-top:22px;flex-wrap:wrap}
.certts{font-size:.72rem;color:var(--muted);margin-top:16px}

/* admin */
.adp{position:relative;z-index:2;min-height:100vh}
.adpass{color:var(--green);font-weight:600;font-size:.78rem}
.adfail{color:var(--red);font-weight:600;font-size:.78rem}

@media(max-width:768px){
  .sec{padding:28px 16px 100px}.cg{grid-template-columns:1fr}
  .sr{gap:8px}.sb{min-width:100px;padding:14px}
  .step{min-width:80px}.sl2{display:none}
  .sc,.certc{padding:28px 22px}
}
@media print{
  .tbar,.bn,.mesh,.certa{display:none!important}
  body{background:#fff;color:#000}
  .certc{border:2px solid #000;box-shadow:none;background:#fff}
}
`;

/* ─── Data ────────────────────────────────────────────────────────────── */
const SEC_NAMES = ["Welcome", "What is Phishing", "How It Works", "Who Targets You", "Brokers Under Attack",
  "Case Study: Cosmos Bank", "Case Study: FYERS Threats", "Broker Scams", "Spot the Phish",
  "Real vs Fake", "What If You Clicked", "Passwords & 2FA", "Social Media Safety",
  "Physical Security", "Safe Browsing", "Your Pledge", "Final Quiz"];

const MQ_ANS = ["b", "b", "b", "b", "b", "b", "b", "b"];
const MQ_EXP = [
  "Phishing happens via email, SMS, WhatsApp, phone calls, social media, and even QR codes.",
  "Attackers exploit your emotions — urgency, fear, curiosity — not technology. That's their primary weapon.",
  "All departments at FYERS handle critical data — customer accounts, API keys, trading systems, financial data. Everyone is a target.",
  "Never click links in KYC messages. Visit your depository's official website or call their verified number directly.",
  "The Cosmos Bank hackers gained entry through a single phishing email clicked by an employee.",
  "Refunds are credited automatically. A \"collect\" request asking for money is always a scam.",
  "An unsolicited OTP means someone has your password and is trying to log in. Change your password immediately.",
  "Never plug unknown USB drives into your computer. They may contain malware. Always hand them to IT security."
];

const QUIZ_ANS = ["c", "b", "b", "b", "b", "c", "c", "c", "b", "c", "b", "b", "b", "b"];
const QUIZ_EXP = [
  "Always verify through a known channel. Logos can be easily copied. IT teams don't send urgent \"click now\" emails.",
  "SEBI never sends compliance checklists via unsolicited email. Always verify with your compliance/CISO team.",
  "Never click links in demat KYC SMS. Visit cdslindia.com or nsdl.co.in directly.",
  "A .pdf.exe file is an executable program disguised as a PDF. This is malware.",
  "SEBI never calls individuals demanding money or threatening arrest.",
  "Vendor bank detail changes must always be verified through out-of-band communication.",
  "Never share identity documents (PAN, Aadhaar) via social media messages.",
  "Even if nothing visible happened, malware can install silently. Report immediately.",
  "Auto-forwarding rules are a common attacker persistence technique.",
  "SEBI's CSCRF mandates all regulated entities report cybersecurity incidents within 6 hours.",
  "Never share your password with anyone — not even colleagues.",
  "Public WiFi is never safe for work. Use your mobile data hotspot or company VPN.",
  "An unlocked computer is an open invitation. Always lock your screen (Win+L / Cmd+L).",
  "Legitimate recruiters never ask for PAN, Aadhaar, or bank details via LinkedIn messages."
];

const QUIZ_QS = [
  { sc: 'You receive an email from "it-support@fyers-helpdesk.net" saying your email storage is 98% full. Click a link to "upgrade storage" within 2 hours or lose access. The email has the company logo.', q: "What should you do?", opts: [{ a: "a", t: "Click the link — it looks legit and has the company logo" }, { a: "b", t: "Reply asking for more information" }, { a: "c", t: "Call the IT helpdesk on their known number to verify" }, { a: "d", t: "Forward it to your team so they can upgrade too" }] },
  { sc: 'You receive an email claiming to be from "SEBI Compliance" asking you to download an "updated CSCRF compliance checklist" attachment urgently before an audit tomorrow.', q: "You should:", opts: [{ a: "a", t: "Download it — SEBI audits are serious" }, { a: "b", t: "Verify with your compliance/CISO team before opening any attachment" }, { a: "c", t: "Forward it to colleagues so everyone is prepared" }, { a: "d", t: "Reply asking for more details" }] },
  { sc: 'SMS: "CDSL Alert: Your demat account KYC has expired. Account will be frozen in 24hrs. Update now: cdsl-kyc-update.co.in/verify"', q: "The correct action is:", opts: [{ a: "a", t: "Click immediately to avoid account freeze" }, { a: "b", t: "Visit cdslindia.com directly (official site) or call their helpline to verify" }, { a: "c", t: "Ignore it completely" }, { a: "d", t: "Reply STOP to the SMS" }] },
  { sc: 'You receive an email attachment named "Q3_Salary_Revision.pdf.exe" from what appears to be hr@fyers.in.', q: "What's suspicious about this?", opts: [{ a: "a", t: "Nothing — it's from HR" }, { a: "b", t: "The .exe extension means it's a program, not a document — this is malware" }, { a: "c", t: "PDFs can't contain viruses so it's fine" }, { a: "d", t: "Only the IT team should worry about file extensions" }] },
  { sc: "Someone calls claiming to be from \"SEBI Enforcement.\" They say your employee ID is linked to insider trading and you'll face criminal charges unless you transfer ₹2 lakh to a \"settlement account\" immediately.", q: "This is:", opts: [{ a: "a", t: "Scary but possibly real — better to comply" }, { a: "b", t: "A vishing scam — SEBI never calls individuals demanding money over phone" }, { a: "c", t: "Real if they know your employee ID" }, { a: "d", t: "Something your compliance team should handle — transfer the money for now" }] },
  { sc: "A vendor you regularly work with emails you a new invoice, but the bank account details are different. The email says: \"We've changed banks. Please update your records.\"", q: "Before processing payment, you should:", opts: [{ a: "a", t: "Process it — the email is from the vendor" }, { a: "b", t: "Reply to the email asking them to confirm" }, { a: "c", t: "Call the vendor on their known phone number to verify the change" }, { a: "d", t: "Check if the new bank is a known bank" }] },
  { sc: "You get a LinkedIn message: \"We have a Senior Manager opening — 3x your current salary. Send your PAN card and Aadhaar to proceed with the offer letter.\"", q: "You should:", opts: [{ a: "a", t: "Send the documents — it's a great opportunity" }, { a: "b", t: "Send only PAN, not Aadhaar" }, { a: "c", t: "Never share identity documents via LinkedIn messages — verify through official channels" }, { a: "d", t: "Ask them to send an email first" }] },
  { sc: "You accidentally clicked a suspicious link 2 hours ago. Nothing seemed to happen. You went about your day.", q: "What should you do NOW?", opts: [{ a: "a", t: "Nothing — if nothing happened, it's probably fine" }, { a: "b", t: "Delete the email and move on" }, { a: "c", t: "Report it to IT security immediately — malware can install silently" }, { a: "d", t: "Run antivirus and consider it handled" }] },
  { sc: "After a phishing incident, you discover that auto-forwarding rules have been set up on your email, sending copies of all your emails to an external address.", q: "This is:", opts: [{ a: "a", t: "Normal email behaviour" }, { a: "b", t: "A common attacker persistence technique — they're reading all your emails silently" }, { a: "c", t: "Only a concern if they have your password" }, { a: "d", t: "Something only IT should care about" }] },
  { sc: "Under SEBI's CSCRF framework for stock brokers and intermediaries, how quickly must a cybersecurity incident be reported?", q: "The mandatory incident reporting timeline is:", opts: [{ a: "a", t: "Within 1 week" }, { a: "b", t: "Within 24 hours" }, { a: "c", t: "Within 6 hours — SEBI mandates rapid reporting for all regulated entities" }, { a: "d", t: "Only after the investigation is complete" }] },
  { sc: "Your colleague asks you to share your password \"just for 5 minutes\" because they're locked out and need to finish something urgent before a deadline.", q: "You should:", opts: [{ a: "a", t: "Share it — they're a trusted colleague and it's urgent" }, { a: "b", t: "Never share your password — ask them to contact IT to reset their own access" }, { a: "c", t: "Share it but change it afterwards" }, { a: "d", t: "Write it on a sticky note for them" }] },
  { sc: "You're working from a coffee shop and need to check an important email from your manager. The coffee shop has free WiFi.", q: "The safest approach is:", opts: [{ a: "a", t: "Connect to the free WiFi — it's convenient and fast" }, { a: "b", t: "Use your mobile data hotspot instead of public WiFi" }, { a: "c", t: "Use the free WiFi but don't do banking" }, { a: "d", t: "Ask the staff for the WiFi password — that makes it secure" }] },
  { sc: "You step away from your desk for a quick tea break. Your computer is unlocked with your email and internal dashboard open.", q: "What's the risk?", opts: [{ a: "a", t: "No risk — it's an office with trusted people" }, { a: "b", t: "Anyone can read emails, copy data, or install malware in seconds — always lock your screen" }, { a: "c", t: "Only a risk if visitors are in the office" }, { a: "d", t: "The screensaver will activate anyway" }] },
  { sc: "A new connection on LinkedIn messages you: \"Hi! I saw you work at FYERS. We're hiring for a similar role at 3x salary. Send your PAN and Aadhaar copy to start the process.\"", q: "This is most likely:", opts: [{ a: "a", t: "A genuine job offer — LinkedIn is professional" }, { a: "b", t: "An identity theft attempt — legitimate recruiters never ask for PAN/Aadhaar via LinkedIn" }, { a: "c", t: "Safe if the person has a company email listed" }, { a: "d", t: "Worth exploring — send them a resume first" }] },
];

const DIFF_EXP = {
  domain: "<strong>Domain:</strong> Real = @hdfcbank.com. Fake = @hdfc-banking.com. Always check the exact domain!",
  urgency: "<strong>Subject:</strong> Real is informational. Fake uses CAPS, \"URGENT\", and threats to create panic.",
  greeting: "<strong>Greeting:</strong> Real uses your name. Fake says \"Valued Customer\" — mass email.",
  url: "<strong>URL:</strong> Real = netbanking.hdfcbank.com. Fake = hdfc-verify-secure.co.in.",
  footer: "<strong>Footer:</strong> Real has CIN, phone, branch info. Fake just says \"HDFC Support Team.\""
};

const ADMIN_CREDS = { user: "admin", pass: "Fyers@2024" };

/* ─── Small Helpers ───────────────────────────────────────────────────── */
function GCard({ color, icon, title, children }) {
  return (
    <div className={`gc ${color}`}>
      <div className="ct">{icon && <span>{icon}</span>}{title}</div>
      {children}
    </div>
  );
}

function MiniQ({ qid, question, opts, onCorrect }) {
  const [done, setDone] = useState(false);
  const [chosen, setChosen] = useState(null);
  function pick(v) {
    if (done) return;
    setDone(true); setChosen(v);
    if (v === MQ_ANS[qid]) onCorrect();
  }
  return (
    <div className="mq">
      <div className="mql">❓ Quick Check</div>
      <h4>{question}</h4>
      <div className="mqo2">
        {opts.map(o => {
          let c = "mqopt";
          if (done) { c += " dis"; if (o.v === MQ_ANS[qid]) c += " cor"; else if (o.v === chosen) c += " wrg"; }
          return <div key={o.v} className={c} onClick={() => pick(o.v)}>{o.t}</div>;
        })}
      </div>
      {done && <div className={`mqfb ${chosen === MQ_ANS[qid] ? "ok" : "no"}`}>{chosen === MQ_ANS[qid] ? `✅ Correct! +3 pts — ` : "❌ "}{MQ_EXP[qid]}</div>}
    </div>
  );
}

/* ─── Sections ────────────────────────────────────────────────────────── */
function S0({ name }) {
  return (
    <div className="sec">
      <div className="logo" style={{ fontSize: "1.6rem", marginBottom: "12px" }}>FYERS<span>.</span></div>
      <h2 style={{ textAlign: "center" }}>Welcome, {name || "Employee"}</h2>
      <p className="lead" style={{ textAlign: "center", margin: "0 auto 24px" }}>
        As employees of <strong style={{ color: "#fff" }}>FYERS</strong> — a SEBI-registered stock broker serving <strong style={{ color: "#fff" }}>1 million+ customers</strong> — we handle trading platforms, customer accounts, API keys, and sensitive financial data every day. A single phishing click can compromise customer accounts and our trading infrastructure. This training is interactive: solve challenges and earn points.
      </p>
      <h3 style={{ textAlign: "center", color: "var(--muted)", fontSize: ".82rem", textTransform: "uppercase", letterSpacing: "2px", marginBottom: "14px" }}>What You'll Learn</h3>
      <div className="cg">
        <GCard color="cyan" icon="🎣" title="What is Phishing"><p>The basics — in plain language, not tech jargon</p></GCard>
        <GCard color="purple" icon="⚙️" title="How Attacks Work"><p>The 5-step process every attacker follows</p></GCard>
        <GCard color="red" icon="📈" title="Brokers Under Attack"><p>SEBI, CERT-In stats and broker-specific threats targeting FYERS</p></GCard>
        <GCard color="amber" icon="📋" title="Real Case Studies"><p>Cosmos Bank heist, broker credential theft, fake SEBI penalty notices</p></GCard>
        <GCard color="orange" icon="📱" title="Broker-Specific Scams"><p>API key phishing, fake KYC, SEBI impersonation, customer data theft</p></GCard>
        <GCard color="green" icon="🔎" title="Spot the Phish"><p>Interactive challenge: find every red flag in a fake email</p></GCard>
      </div>
    </div>
  );
}

function S1({ addPts }) {
  return (
    <div className="sec">
      <div className="snum">1</div>
      <h2>What is Phishing?</h2>
      <p className="lead">Think of it like <span className="hl">fishing with a fake bait</span> — but the "fish" is you, and the bait is a message designed to trick you.</p>
      <div className="cg">
        <GCard color="cyan" icon="📩" title="The Simple Definition">
          <p>A criminal <strong style={{ color: "#fff" }}>pretends to be someone you trust</strong> — your bank, your boss, the IT team — and sends a fake message to trick you into:</p>
          <ul><li>Clicking a dangerous link</li><li>Sharing passwords, OTPs, or PINs</li><li>Downloading a harmful file</li><li>Transferring money</li></ul>
        </GCard>
        <GCard color="orange" icon="📱" title="Not Just Email!">
          <p>Phishing happens on many channels:</p>
          <ul>
            <li><strong style={{ color: "#fff" }}>SMS</strong> — "Smishing" (fake KYC, bank alerts)</li>
            <li><strong style={{ color: "#fff" }}>Phone calls</strong> — "Vishing" (fake RBI/bank officers)</li>
            <li><strong style={{ color: "#fff" }}>WhatsApp</strong> — fastest growing in India</li>
            <li><strong style={{ color: "#fff" }}>Social media</strong> — fake profiles, DMs, job offers</li>
            <li><strong style={{ color: "#fff" }}>QR codes</strong> — "Quishing" (malicious scan-to-pay)</li>
          </ul>
        </GCard>
      </div>
      <div className="tw"><strong>Key point:</strong> Phishing is about <strong>deception, not technology</strong>. You don't need to be a "tech person" to be targeted. If you have an email, bank account, or phone — <strong>you are a target.</strong></div>
      <MiniQ qid={0} question="True or False: Phishing only happens through email." onCorrect={() => addPts(3)}
        opts={[{ v: "a", t: "True — email is the only channel" }, { v: "b", t: "False — it also happens via SMS, calls, WhatsApp, and social media" }]} />
    </div>
  );
}

function S2({ addPts }) {
  return (
    <div className="sec">
      <div className="snum">2</div>
      <h2>How Does Phishing Work?</h2>
      <p className="lead">Every phishing attack follows the <span className="hl">same 5-step playbook</span>. Understanding it is your first defense.</p>
      <div className="steps">
        {[["🎭", "1. Disguise", "Poses as your bank, boss, or IT dept"], ["📨", "2. Bait", "\"Act NOW!\" — urgent, scary, or exciting"], ["🖱️", "3. Click", "You click a link or open a file"], ["🔓", "4. Captured", "Credentials, OTP, or data stolen"], ["💸", "5. Damage", "Money gone, data leaked"]].map(([ic, ti, de], i, a) => (
          <div className="step" key={i}><div className="si">{ic}</div>{i < a.length - 1 && <div className="sl2" />}<div className="sti">{ti}</div><div className="std">{de}</div></div>
        ))}
      </div>
      <div className="cg" style={{ marginTop: "20px" }}>
        <GCard color="red" icon="⏱️" title="Why Urgency Works"><p>Scammers create <strong style={{ color: "#fff" }}>artificial deadlines</strong>: "Account blocked in 24 hours!" — forcing you to act before you think.</p></GCard>
        <GCard color="green" icon="🛡️" title="Your Antidote"><p><strong style={{ color: "#fff" }}>Pause. Think. Verify.</strong> Those 10 seconds of hesitation are the difference between safety and disaster.</p></GCard>
      </div>
      <MiniQ qid={1} question="An attacker's primary weapon in phishing is:" onCorrect={() => addPts(3)}
        opts={[{ v: "a", t: "Advanced hacking software" }, { v: "b", t: "Your trust and emotions (urgency, fear, curiosity)" }, { v: "c", t: "Expensive equipment" }]} />
    </div>
  );
}

function S3({ addPts }) {
  return (
    <div className="sec">
      <div className="snum">3</div>
      <h2>Who Targets You — and Why?</h2>
      <p className="lead">It's not always a shadowy hacker. The attackers are varied — and their goals are very specific.</p>
      <div className="cg">
        <GCard color="red" icon="💰" title="Financial Criminals"><p><strong style={{ color: "#fff" }}>Goal:</strong> Steal customer funds via OTPs, trading credentials, and payment gateway access.</p></GCard>
        <GCard color="purple" icon="📈" title="Account Hijackers"><p><strong style={{ color: "#fff" }}>Goal:</strong> Steal FYERS API keys, trading credentials, or customer login details for <strong style={{ color: "#fff" }}>unauthorised trades and fund withdrawals</strong>.</p></GCard>
        <GCard color="amber" icon="🏢" title="Data Thieves"><p><strong style={{ color: "#fff" }}>Goal:</strong> Harvest customer PII (PAN, Aadhaar, bank details), client portfolios, and proprietary trading algorithms.</p></GCard>
        <GCard color="orange" icon="🌐" title="State-Sponsored / APTs"><p><strong style={{ color: "#fff" }}>Goal:</strong> Disrupt financial infrastructure. India saw <strong style={{ color: "#fff" }}>300% rise</strong> in targeted attacks on financial institutions since 2022.</p></GCard>
      </div>
      <div className="tw"><strong>Why FYERS?</strong> As a SEBI-registered broker with <strong>1M+ customers</strong>, NSE/BSE/MCX membership, and NSDL/CDSL depository participation — FYERS holds massive amounts of customer data, trading credentials, and financial information. <strong>You are a high-value target.</strong></div>
      <MiniQ qid={2} question="Why are FYERS employees prime targets for phishing?" onCorrect={() => addPts(3)}
        opts={[{ v: "a", t: "Only the Technology team" }, { v: "b", t: "All departments — FYERS handles customer accounts, trading data, API keys, and financial information" }, { v: "c", t: "Only senior management" }]} />
    </div>
  );
}

function S4({ addPts }) {
  return (
    <div className="sec">
      <div className="snum">4</div>
      <h2>Stock Brokers Under Attack</h2>
      <p className="lead">Stock brokers like FYERS are <span className="dg">SEBI-regulated intermediaries</span> handling millions in customer assets.</p>
      <div className="sr">
        <div className="sb"><div className="sbn red">₹1,750 Cr</div><div className="sbl">Lost to cyber fraud<br />in India (2024)</div></div>
        <div className="sb"><div className="sbn amber">15.9 lakh</div><div className="sbl">Cyber incidents<br />handled by CERT-In</div></div>
        <div className="sb"><div className="sbn">12.5 Cr+</div><div className="sbl">Active demat<br />accounts in India</div></div>
      </div>
      <h3>Threats Specific to Stock Brokers Like FYERS</h3>
      <div className="cg">
        <GCard color="red" icon="🔑" title="API Key Theft"><p>FYERS offers a trading API used by algo traders. Phishing to steal <strong style={{ color: "#fff" }}>API keys and access tokens</strong> can enable unauthorised trades.</p></GCard>
        <GCard color="amber" icon="💳" title="Customer Account Takeover"><p>Fake "KYC expiring" emails. Steal credentials to <strong style={{ color: "#fff" }}>withdraw funds or transfer shares</strong>.</p></GCard>
        <GCard color="orange" icon="📧" title="Fake SEBI Penalty Notices"><p>Attackers know FYERS received a real SEBI penalty for BCP/DR gaps — making fake follow-up notices <strong style={{ color: "#fff" }}>extremely convincing</strong>.</p></GCard>
        <GCard color="purple" icon="📱" title="Fake Trading Alerts &amp; Tips"><p>"Guaranteed returns!" WhatsApp groups impersonating FYERS advisors, fake stock tips, phishing links disguised as trading platform login pages.</p></GCard>
      </div>
      <h3 style={{ marginTop: "20px" }}>📅 Timeline: Attacks on Indian Capital Markets</h3>
      <div className="tl">
        {[["2015", "NSE Co-location Controversy", "Certain brokers allegedly gained unfair access to NSE's co-location servers."],
        ["2016", "3.2 Million Debit Cards Breached", "Malware in Hitachi payment switch. SBI, ICICI, Axis Bank cards compromised."],
        ["2018", "Cosmos Bank — ₹94 Cr Heist", "Phishing email → malware → 14,849 ATM withdrawals across 28 countries. SWIFT system exploited."],
        ["2021", "SEBI Issues CSCRF Framework", "Cyber Security and Cyber Resilience Framework mandated for all MIIs, stock brokers, depositories, and mutual funds."],
        ["2023", "Broker Terminal Phishing Surge", "Multiple brokerages targeted with fake \"SEBI compliance\" emails. Credentials stolen."],
        ["2024", "SEBI Tightens CSCRF for Brokers", "Updated framework mandates SOC, regular VAPT, incident reporting within 6 hours."],
        ["2024", "SEBI Penalises FYERS for BCP/DR Gaps", "FYERS received ₹4 lakh penalty for BCP deficiencies — making fake \"SEBI penalty follow-up\" phishing emails extremely convincing."],
        ].map(([yr, ti, de], i) => (
          <div className="tli" key={i}><div className="tld" /><div className="tly">{yr}</div><div className="tlt">{ti}</div><div className="tldc">{de}</div></div>
        ))}
      </div>
      <div className="tw"><strong>SEBI CSCRF mandates:</strong> Stock brokers must conduct <strong>regular cybersecurity awareness training</strong> for all employees. <strong>SEBI requires incident reporting within 6 hours.</strong> FYERS is ISO 27001:2022 certified.</div>
      <MiniQ qid={3} question={"Your bank sends an SMS: \"KYC expiring in 24hrs. Click link to update.\" What do you do?"} onCorrect={() => addPts(3)}
        opts={[{ v: "a", t: "Click the link quickly before the deadline" }, { v: "b", t: "Ignore it — visit your bank branch or call their official number instead" }, { v: "c", t: "Forward it to colleagues so they can update too" }]} />
    </div>
  );
}

function S5() {
  return (
    <div className="sec">
      <div className="snum">5</div>
      <h2>Case Study: Cosmos Bank Heist</h2>
      <div className="cb">
        <span className="ctag">Real Incident — August 2018</span>
        <h3>Cosmos Co-operative Bank, Pune</h3>
        <div className="cmeta"><span>💸 ₹94 Crore stolen</span><span>⏱️ 2 days</span><span>🌍 28 countries</span></div>
        <p style={{ fontSize: ".88rem", lineHeight: "1.7" }}><strong style={{ color: "#fff" }}>The Attack Chain:</strong></p>
        <div className="steps" style={{ margin: "14px 0" }}>
          {[["📧", "Phishing Email", "Employee clicks a fake internal email"], ["🐛", "Malware Installed", "Silently infects core banking systems"], ["💳", "Cards Cloned", "Thousands of debit card details copied"], ["🏧", "ATM Withdrawals", "14,849 transactions across 28 countries"], ["💸", "SWIFT Transfer", "₹13.92 Cr sent to Hong Kong"]].map(([ic, ti, de], i, a) => (
            <div className="step" key={i}><div className="si" style={{ fontSize: "1rem" }}>{ic}</div>{i < a.length - 1 && <div className="sl2" />}<div className="sti">{ti}</div><div className="std">{de}</div></div>
          ))}
        </div>
        <div className="cl"><strong>💡 The Lesson:</strong><p>Attackers <strong>didn't hack through a firewall</strong>. They walked through the front door because <strong>one employee clicked one email</strong>. That click cost ₹94 crore.</p></div>
      </div>
    </div>
  );
}

function S6({ addPts }) {
  return (
    <div className="sec">
      <div className="snum">6</div>
      <h2>Case Study: Fake SEBI Penalty + API Key Theft</h2>
      <div className="cb">
        <span className="ctag">High Risk for FYERS — Ongoing</span>
        <h3>Fake SEBI Penalty Follow-Up Email</h3>
        <div className="cmeta"><span>🎯 Risk, Compliance & Leadership</span><span>📧 Email spoofing</span></div>
        <p style={{ fontSize: ".88rem", lineHeight: "1.7" }}><strong style={{ color: "#fff" }}>Why this is dangerous:</strong> SEBI actually penalised FYERS ₹4 lakh for BCP/DR non-compliance. Attackers can craft fake follow-up notices referencing <strong style={{ color: "#fff" }}>real penalty details</strong>.</p>
        <div className="cl"><strong>💡 The Lesson:</strong><p>Attackers research their targets. Always verify SEBI communications through official SEBI website (sebi.gov.in) or your compliance team.</p></div>
      </div>
      <div className="cb" style={{ marginTop: "14px", borderColor: "rgba(139,92,246,.12)" }}>
        <span className="ctag" style={{ background: "linear-gradient(135deg,#6d28d9,var(--purple))" }}>Broker-Specific — 2023-24</span>
        <h3>FYERS API Credential Phishing</h3>
        <div className="cmeta"><span>🔑 API keys & access tokens</span><span>📈 Algo trading accounts</span></div>
        <p style={{ fontSize: ".88rem", lineHeight: "1.7" }}>Attackers send fake emails: <strong style={{ color: "#fff" }}>"FYERS API v3 Migration — Update your credentials before March 31 or lose API access."</strong> Stolen API keys are used to <span className="dg">place unauthorised trades, drain customer accounts</span>.</p>
        <div className="cl"><strong>💡 The Lesson:</strong><p>API keys are <strong>as valuable as passwords</strong>. FYERS will never ask for API credentials via email.</p></div>
      </div>
      <MiniQ qid={4} question="In the Cosmos Bank attack, how did the hackers first get inside the system?" onCorrect={() => addPts(3)}
        opts={[{ v: "a", t: "They broke through the firewall with brute force" }, { v: "b", t: "An employee clicked a phishing email" }, { v: "c", t: "They guessed the admin password" }]} />
    </div>
  );
}

function S7({ addPts }) {
  const [scAns, setScAns] = useState(null);
  const correct = "b";
  const exp = {
    a: "❌ SEBI will never ask for login credentials via WhatsApp. This is social engineering. Never share credentials.",
    b: "✅ Correct! SEBI never contacts individuals via WhatsApp or asks for credentials. Report to your CISO/compliance team immediately.",
    c: "❌ Don't engage with the scammer at all — replying confirms your number is active."
  };
  function pick(v) {
    if (scAns) return;
    setScAns(v);
    if (v === correct) addPts(5);
  }
  return (
    <div className="sec">
      <div className="snum">7</div>
      <h2>Broker-Specific Scams: SMS, WhatsApp & Impersonation</h2>
      <p className="lead">These are the scams targeting <span className="hl">FYERS employees, customers, and capital market participants</span>.</p>
      <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", justifyContent: "center", margin: "16px 0" }}>
        <div>
          <div className="pm">
            <div className="pn" />
            <div className="pb2" style={{ background: "#0b141a" }}>
              <div className="wam"><div className="wan">+91 98765 XXXXX</div>Hi, I'm from SEBI Investigation Dept. Your FYERS employee ID is linked to suspicious trading. Share your employee portal login for verification. <span style={{ color: "#53bdeb", textDecoration: "underline" }}>sebi-verify.co.in/emp</span><div className="wat">10:32 AM ✓✓</div></div>
              <div className="wam wao"><div style={{ color: "#53bdeb", fontSize: ".72rem" }}>You</div>Who is this?<div className="wat">10:33 AM ✓✓</div></div>
              <div className="wam"><div className="wan">+91 98765 XXXXX</div>This is urgent and confidential. Respond within 1 hour.<div className="wat">10:33 AM ✓✓</div></div>
            </div>
          </div>
          <div className="pl">🚨 Fake SEBI WhatsApp</div>
        </div>
        <div>
          <div className="pm">
            <div className="pn" />
            <div className="pb2">
              <div className="sms"><strong style={{ color: "var(--red)" }}>CDSL-ALERT:</strong> Your demat KYC has expired. Account will be frozen. Update now: <span style={{ color: "var(--red)", textDecoration: "underline" }}>cdsl-kyc-update.co.in</span></div>
              <div className="sms" style={{ marginTop: "12px" }}><strong style={{ color: "var(--amber)" }}>SEBI-NOTICE:</strong> Penalty of Rs.50,000 imposed for non-compliance. Pay now: <span style={{ color: "var(--red)", textDecoration: "underline" }}>sebi-penalty-pay.in/settle</span></div>
            </div>
          </div>
          <div className="pl">🚨 Demat / SEBI SMS Scams</div>
        </div>
      </div>
      <h3>🤔 What Would You Do?</h3>
      <div className="scbox">
        <div className="scq">You receive a WhatsApp from an unknown number: <em>"This is from SEBI Surveillance. Unusual trading detected from FYERS' systems. Share your employee portal credentials immediately for our investigation, or FYERS' trading licence will be reviewed. Strictly confidential."</em></div>
        <div className="sccs">
          {[{ v: "a", t: "Share credentials — SEBI investigation sounds serious" }, { v: "b", t: "Report to FYERS' CISO/compliance team — SEBI never asks for credentials via WhatsApp" }, { v: "c", t: "Reply on WhatsApp asking them to send an official email" }].map(ch => {
            let c = "scc";
            if (scAns) { c += " dis"; if (ch.v === correct) c += " cor"; else if (ch.v === scAns) c += " wrg"; }
            return <div key={ch.v} className={c} onClick={() => pick(ch.v)}>{ch.t}</div>;
          })}
        </div>
        {scAns && <div className={`scf ${scAns === correct ? "ok" : "no"}`}>{exp[scAns]}</div>}
      </div>
      <MiniQ qid={5} question={"A UPI \"collect\" request appears from an unknown person claiming it's a \"refund.\" You should:"} onCorrect={() => addPts(3)} opts={[{ v: "a", t: "Accept it — refunds need to be collected" }, { v: "b", t: "Decline it — refunds never require you to accept a collect request" }, { v: "c", t: "Wait and see what happens" }]} />
    </div>
  );
}

function S8({ addPts }) {
  const [flags, setFlags] = useState({});
  const cnt = Object.keys(flags).length;
  function hit(f) {
    if (flags[f]) return;
    const nf = { ...flags, [f]: true };
    setFlags(nf);
    if (Object.keys(nf).length >= 6) addPts(10 - cnt);
    else addPts(1);
  }
  function RF({ flag, tip }) {
    const found = !!flags[flag];
    return (
      <span className="rfz" onClick={() => hit(flag)}>
        <span className={`rfb${found ? " found" : ""}`}>{found ? "✅ FOUND" : "🚩 FLAG?"}</span>
        <span className="rft">{tip}</span>
      </span>
    );
  }
  return (
    <div className="sec">
      <div className="snum">8</div>
      <h2>Spot the Phish — Interactive Exercise</h2>
      <p className="lead"><span className="hl">Click on every red flag</span> in the email below. Find all 6 to earn maximum points!</p>
      <div className="stpc">Red flags found: <span>{cnt}</span> / 6</div>
      <div className="em">
        <div className="ech"><div className="dot" style={{ background: "#ff5f57" }} /><div className="dot" style={{ background: "#febc2e" }} /><div className="dot" style={{ background: "#28c840" }} /><span style={{ marginLeft: "10px", fontSize: ".7rem", color: "var(--muted)" }}>Inbox — 1 unread</span></div>
        <div className="eh">
          <div className="ehr"><span className="ehl">From:</span><span className="ehv bad">HDFC Support &lt;support@hdfc-logins.com&gt; <RF flag="domain" tip="FAKE DOMAIN! Real HDFC = @hdfcbank.com. This is 'hdfc-logins.com' — a look-alike domain created by scammers." /></span></div>
          <div className="ehr"><span className="ehl">To:</span><span className="ehv">you@fyers.in</span></div>
          <div className="ehr"><span className="ehl">Subject:</span><span className="ehv bad">⚠️ URGENT: Account Suspended in 24hrs — Immediate Action Required <RF flag="urgency" tip="FAKE URGENCY! Real banks never threaten suspension via email. This panics you into clicking without thinking." /></span></div>
        </div>
        <div className="eb">
          <p>Dear Valued Customer, <RF flag="generic" tip="GENERIC GREETING! Your real bank knows your name. 'Valued Customer' = mass email sent to thousands." /></p>
          <p style={{ marginTop: "10px" }}>We have detected unusual activty on your account. Your account will be <strong style={{ color: "var(--red)" }}>permanantly suspended</strong> unless you verify within 24 hours. <RF flag="spelling" tip="SPELLING ERRORS! 'activty' and 'permanantly' — real bank communications are proofread. Classic phishing sign." /></p>
          <p style={{ marginTop: "10px" }}>Please verify immediately: <span className="furl">https://hdfc-secure-verify.com/account/login</span> <RF flag="url" tip="FAKE URL! Not hdfcbank.com. Scammers create domains like 'hdfc-secure-verify.com' that sound official but are fake." /></p>
          <p style={{ marginTop: "12px" }}>Regards,<br />HDFC Security Team <RF flag="noinfo" tip="NO CONTACT INFO! Real bank emails include phone numbers, branch details, regulatory disclaimers. This has none." /></p>
        </div>
      </div>
      {cnt >= 6 && <div className="stpr gr">🎉 <strong>Amazing!</strong> You found all 6 red flags! +10 pts</div>}
      {cnt > 0 && cnt < 6 && <div className="stpr ok2">Good eye! Found {cnt} of 6 flags. Keep looking!</div>}
      <div className="tw" style={{ marginTop: "16px" }}><strong>Golden Rule:</strong> Don't click, don't reply, don't panic. <strong>Verify through a channel you already trust.</strong></div>
    </div>
  );
}

function S9({ addPts }) {
  const [diffs, setDiffs] = useState({});
  const [lastExp, setLastExp] = useState(null);
  const cnt = Object.keys(diffs).length;
  function hit(d) {
    if (diffs[d]) return;
    const nd = { ...diffs, [d]: true };
    setDiffs(nd);
    setLastExp(DIFF_EXP[d]);
    if (Object.keys(nd).length >= 5) addPts(8 - cnt);
    else addPts(1);
  }
  function DZ({ diff, children }) {
    return <span className={`dz${diffs[diff] ? " found" : ""}`} onClick={() => hit(diff)}>{children}</span>;
  }
  return (
    <div className="sec">
      <div className="snum">9</div>
      <h2>Real vs Fake — Can You Tell?</h2>
      <p className="lead">One is <span className="hl">genuine</span>, the other is <span className="dg">phishing</span>. <strong style={{ color: "#fff" }}>Click on the differences</strong> you spot in the fake email.</p>
      <div className="cctr">Differences found: <span>{cnt}</span> / 5</div>
      <div className="cgrid">
        <div className="cpanel">
          <span className="clbl real">✅ Real Email</span>
          <div className="em" style={{ borderColor: "rgba(16,185,129,.2)", margin: "8px 0" }}>
            <div className="ech" style={{ borderColor: "rgba(16,185,129,.1)" }}><div className="dot" style={{ background: "#ff5f57" }} /><div className="dot" style={{ background: "#febc2e" }} /><div className="dot" style={{ background: "#28c840" }} /><span style={{ marginLeft: "10px", fontSize: ".7rem", color: "var(--muted)" }}>Verified sender</span></div>
            <div className="eh">
              <div className="ehr"><span className="ehl">From:</span><span className="ehv" style={{ color: "var(--green)" }}>alerts@hdfcbank.com</span></div>
              <div className="ehr"><span className="ehl">Subject:</span><span className="ehv">Your HDFC Bank statement for February 2025</span></div>
            </div>
            <div className="eb" style={{ fontSize: ".8rem" }}>
              <p>Dear <strong>Priya Sharma</strong>,</p>
              <p style={{ marginTop: "8px" }}>Your monthly account statement for A/c XXXX1234 is now available at <span style={{ color: "var(--green)" }}>netbanking.hdfcbank.com</span></p>
              <p style={{ marginTop: "8px", fontSize: ".74rem", color: "var(--muted)" }}>For queries, call 1800-202-6161.<br />HDFC Bank Ltd. CIN: L65920MH1994PLC080618</p>
            </div>
          </div>
        </div>
        <div className="cpanel">
          <span className="clbl fake">❌ Phishing Email</span>
          <div className="em" style={{ borderColor: "rgba(239,68,68,.2)", margin: "8px 0" }}>
            <div className="ech" style={{ borderColor: "rgba(239,68,68,.1)" }}><div className="dot" style={{ background: "#ff5f57" }} /><div className="dot" style={{ background: "#febc2e" }} /><div className="dot" style={{ background: "#28c840" }} /><span style={{ marginLeft: "10px", fontSize: ".7rem", color: "var(--muted)" }}>Inbox</span></div>
            <div className="eh">
              <div className="ehr"><span className="ehl">From:</span><span className="ehv bad"><DZ diff="domain">alerts@hdfc-banking.com</DZ></span></div>
              <div className="ehr"><span className="ehl">Subject:</span><span className="ehv bad"><DZ diff="urgency">URGENT: Your account will be SUSPENDED — verify NOW</DZ></span></div>
            </div>
            <div className="eb" style={{ fontSize: ".8rem" }}>
              <p><DZ diff="greeting">Dear Valued Customer</DZ>,</p>
              <p style={{ marginTop: "8px" }}>Please verify your identity: <DZ diff="url"><span style={{ color: "var(--red)", textDecoration: "underline" }}>https://hdfc-verify-secure.co.in/login</span></DZ></p>
              <p style={{ marginTop: "8px", fontSize: ".74rem", color: "var(--muted)" }}><DZ diff="footer">HDFC Support Team.</DZ></p>
            </div>
          </div>
        </div>
      </div>
      {lastExp && <div className="cex" dangerouslySetInnerHTML={{ __html: lastExp }} />}
      {cnt >= 5 && <div className="stpr gr" style={{ marginTop: "8px" }}>🎉 <strong>Excellent!</strong> You found all 5 differences! +8 pts.</div>}
      <div className="tw" style={{ marginTop: "12px" }}><strong>Quick check method:</strong> Real bank emails use your <strong>real name</strong>, come from the <strong>exact official domain</strong>, include <strong>regulatory info</strong>, and <strong>never ask you to click urgently</strong>.</div>
    </div>
  );
}

function S10() {
  return (
    <div className="sec">
      <div className="snum">10</div>
      <h2>What To Do If You Clicked</h2>
      <p className="lead">Mistakes happen. What matters is <span className="hl">how fast you respond</span>.</p>
      <div className="cg" style={{ gridTemplateColumns: "1fr" }}>
        {[["red", "1️⃣", "DISCONNECT", "Turn off WiFi / unplug network cable. This may stop data from being sent to the attacker."],
        ["amber", "2️⃣", "CHANGE PASSWORDS", "Immediately change passwords for any account you entered on the fake site. Use a different device."],
        ["orange", "3️⃣", "ALERT FYERS IT SECURITY / CISO", "Report to FYERS' CISO or IT Security team immediately. Under SEBI CSCRF, incidents must be reported within <strong style='color:#fff'>6 hours</strong>."],
        ["purple", "4️⃣", "SECURE YOUR ACCOUNTS", "If trading platform or API credentials were exposed, request immediate password reset, revoke API keys, and terminate active sessions."],
        ["cyan", "5️⃣", "REPORT TO AUTHORITIES", "File a complaint at <strong style='color:#fff'>cybercrime.gov.in</strong> or helpline <strong style='color:#fff'>1930</strong>."],
        ["green", "6️⃣", "MONITOR FOR 30 DAYS", "Watch for unauthorised transactions. Check email for suspicious forwarding rules set by the attacker."],
        ].map(([color, num, title, desc]) => (
          <div key={title} className={`gc ${color}`} style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
            <div style={{ fontSize: "1.6rem", flexShrink: 0 }}>{num}</div>
            <div><strong style={{ color: "#fff" }}>{title}</strong><p dangerouslySetInnerHTML={{ __html: desc }} /></div>
          </div>
        ))}
      </div>
      <div className="tw"><strong>Remember:</strong> Your reporting speed directly impacts <strong>customer safety and market integrity</strong>. SEBI CSCRF requires incidents reported within 6 hours. Reporting is your <strong>regulatory duty</strong>.</div>
    </div>
  );
}

function S11({ addPts }) {
  return (
    <div className="sec">
      <div className="snum">11</div>
      <h2>Password Security & Two-Factor Authentication</h2>
      <p className="lead">Weak passwords are the <span className="dg">#1 reason</span> accounts get hacked.</p>
      <div className="cg">
        <GCard color="red" icon="❌" title="Bad Passwords (Don't Use These!)">
          <ul><li>123456, password, qwerty</li><li>Your name, birthday, pet's name</li><li>Company name: "fyers123"</li><li>Same password for everything</li></ul>
        </GCard>
        <GCard color="green" icon="✅" title="Strong Passwords (Do This!)">
          <ul><li>Use a <strong style={{ color: "#fff" }}>passphrase</strong>: "MyCoffeeHas3Sugars!" — long and hard to crack</li><li>At least <strong style={{ color: "#fff" }}>12 characters</strong> with mixed case, numbers, symbols</li><li><strong style={{ color: "#fff" }}>Different password</strong> for every account</li><li>Use a <strong style={{ color: "#fff" }}>password manager</strong></li></ul>
        </GCard>
      </div>
      <h3>What is Two-Factor Authentication (2FA)?</h3>
      <div className="cg" style={{ gridTemplateColumns: "1fr" }}>
        <GCard color="cyan" icon="📱" title="Your Second Lock">
          <p>Even if someone steals your password, <strong style={{ color: "#fff" }}>2FA stops them</strong>. It's like having two locks on your door — they need both keys.</p>
          <p style={{ marginTop: "8px" }}><strong style={{ color: "var(--green)" }}>Enable 2FA on:</strong> Your FYERS work email, FYERS dashboard, personal email, banking apps, social media — everywhere it's available.</p>
        </GCard>
      </div>
      <div className="tw"><strong>Golden rule:</strong> Use <strong>unique passwords + 2FA</strong> on every account. If you get an OTP you didn't request — someone has your password. <strong>Change it immediately and report it.</strong></div>
      <MiniQ qid={6} question="You get an OTP on your phone that you didn't request. What does this mean?" onCorrect={() => addPts(3)}
        opts={[{ v: "a", t: "It's a system glitch — ignore it" }, { v: "b", t: "Someone likely has your password and is trying to log in — change it immediately" }, { v: "c", t: "Share the OTP if someone calls asking for it" }]} />
    </div>
  );
}

function S12() {
  return (
    <div className="sec">
      <div className="snum">12</div>
      <h2>Social Media & Information Sharing</h2>
      <p className="lead">What you share online can be <span className="dg">used against you</span> by attackers.</p>
      <div className="cg">
        <GCard color="red" icon="🚫" title="Never Share Publicly">
          <ul><li>Your employee ID or access card photos</li><li>Screenshots of internal tools, dashboards, or emails</li><li>Office layout, server room, or security setup photos</li><li>Project names, client names, or upcoming features</li><li>Your work email address on public forums</li></ul>
        </GCard>
        <GCard color="amber" icon="⚠️" title="How Attackers Use Social Media">
          <ul>
            <li><strong style={{ color: "#fff" }}>LinkedIn:</strong> Find your role, team, and who you report to — then impersonate your boss</li>
            <li><strong style={{ color: "#fff" }}>Instagram/Facebook:</strong> Learn your birthday, pet's name — to guess passwords</li>
            <li><strong style={{ color: "#fff" }}>Twitter/X:</strong> See what tools/systems you use — to craft targeted phishing</li>
          </ul>
        </GCard>
      </div>
      <div className="cg" style={{ gridTemplateColumns: "1fr" }}>
        <GCard color="orange" icon="💼" title="The LinkedIn Trap">
          <p>Attacker sees: <em>"Priya Sharma — Risk Analyst at FYERS, reports to Rahul (VP Risk)"</em>. They send Priya: <em>"Hi Priya, Rahul here. I'm in a meeting — can you urgently process this payment?"</em> <strong style={{ color: "#fff" }}>This is spear phishing</strong> — and social media makes it easy.</p>
        </GCard>
      </div>
      <div className="tw"><strong>Think before you post:</strong> Could this help someone pretend to be me, my colleague, or my company? If yes — <strong>don't post it.</strong></div>
    </div>
  );
}

function S13({ addPts }) {
  return (
    <div className="sec">
      <div className="snum">13</div>
      <h2>Physical Security & Clean Desk</h2>
      <p className="lead">Cybersecurity isn't just digital. <span className="hl">Physical access</span> to your workspace can be just as dangerous.</p>
      <div className="cg">
        <GCard color="red" icon="🚪" title="Tailgating"><p>Someone follows you through a secured door without swiping their own card. <strong style={{ color: "#fff" }}>Always make visitors badge in separately.</strong></p></GCard>
        <GCard color="amber" icon="💻" title="Unattended Devices"><p>Stepping away for "just 2 minutes" with your laptop unlocked? That's enough time to install malware or copy files. <strong style={{ color: "#fff" }}>Lock your screen every single time (Win+L / Cmd+L).</strong></p></GCard>
        <GCard color="orange" icon="📋" title="Clean Desk Policy"><p>Sticky notes with passwords, printed customer data, access cards left on desks — all goldmines. <strong style={{ color: "#fff" }}>Clear your desk at end of day.</strong></p></GCard>
        <GCard color="purple" icon="💾" title="Unknown USB Drives"><p>Found a USB stick in the parking lot? <strong style={{ color: "#fff" }}>Never plug it in.</strong> Attackers "drop" infected USBs. Hand it to IT security.</p></GCard>
      </div>
      <div className="tw"><strong>Remember:</strong> Lock your screen. Badge in individually. Never plug in unknown USB drives. Keep your desk clear of sensitive documents.</div>
      <MiniQ qid={7} question="You find a USB drive in the office pantry. What should you do?" onCorrect={() => addPts(3)}
        opts={[{ v: "a", t: "Plug it into your computer to see whose it is" }, { v: "b", t: "Hand it to IT security — never plug unknown devices into your computer" }, { v: "c", t: "Throw it in the trash" }]} />
    </div>
  );
}

function S14() {
  return (
    <div className="sec">
      <div className="snum">14</div>
      <h2>Safe Browsing & Working Remotely</h2>
      <p className="lead">Whether in the office or at home, <span className="hl">how you connect matters</span>.</p>
      <div className="cg">
        <GCard color="red" icon="📶" title="Public WiFi = Public Risk">
          <p><strong style={{ color: "#fff" }}>Anyone on the same network can see your traffic.</strong> Never access FYERS systems, banking, or email on public WiFi without a VPN.</p>
          <ul><li>Use your mobile hotspot instead</li><li>If you must use public WiFi, use the company VPN</li><li>Never do banking or trading on public networks</li></ul>
        </GCard>
        <GCard color="green" icon="🛡️" title="Safe Browsing Habits">
          <ul>
            <li>Look for <strong style={{ color: "#fff" }}>https://</strong> before entering any credentials</li>
            <li>Don't download software from random websites</li>
            <li>Keep your browser and OS <strong style={{ color: "#fff" }}>updated</strong></li>
            <li>Don't save passwords in your browser — use a password manager</li>
            <li>Be wary of pop-ups saying "Your computer is infected!"</li>
          </ul>
        </GCard>
      </div>
      <h3>Working From Home Safely</h3>
      <div className="cg" style={{ gridTemplateColumns: "1fr" }}>
        <GCard color="cyan" icon="🏠" title="Home Office Security Checklist">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 20px", marginTop: "8px" }}>
            {["Change your WiFi router's default password", "Keep work and personal devices separate", "Don't let family members use your work laptop", "Lock your screen even at home", "Use the company VPN for all work", "Don't print sensitive documents at home"].map(t => (
              <p key={t} style={{ fontSize: ".84rem" }}>✅ {t}</p>
            ))}
          </div>
        </GCard>
      </div>
      <div className="tw"><strong>Bottom line:</strong> Treat your home office with the <strong>same security mindset</strong> as the FYERS office. Public WiFi is never safe for work.</div>
    </div>
  );
}

function S15({ addPts }) {
  const [checked, setChecked] = useState({});
  const [done, setDone] = useState(false);
  const items = [
    { id: "p0", t: "STOP and THINK before clicking any link", d: "If it's urgent or too good to be true — pause 10 seconds. That's all it takes." },
    { id: "p1", t: "NEVER share OTPs, passwords, or PINs with anyone", d: "Not IT support, not your manager, not someone claiming to be from your bank." },
    { id: "p2", t: "CHECK the sender's actual email domain", d: "Look beyond the display name. Check the @domain after it." },
    { id: "p3", t: "VERIFY unusual requests through a different channel", d: '"CEO" emails asking for payment? Call them on their known number.' },
    { id: "p4", t: "REPORT suspicious emails immediately", d: "Reporting is a sign of responsibility, not weakness." },
    { id: "p5", t: "USE strong, unique passwords + enable 2FA", d: "Enable two-factor authentication on all accounts." },
  ];
  function toggle(id) {
    if (checked[id]) return;
    const nc = { ...checked, [id]: true };
    setChecked(nc);
    if (Object.keys(nc).length >= 6 && !done) { setDone(true); addPts(5); }
  }
  return (
    <div className="sec">
      <div className="snum">15</div>
      <h2>Be the Firewall — Your Pledge</h2>
      <p className="lead">As a FYERS employee, you protect over 1 million customers and their financial data. <span className="hl">You are the strongest defense.</span> Click each item to pledge.</p>
      <div className="cl2">
        {items.map(({ id, t, d }) => (
          <div key={id} className={`ci${checked[id] ? " ck" : ""}`} onClick={() => toggle(id)}>
            <div className="cb2">{checked[id] && <svg viewBox="0 0 24 24" style={{ width: "12px", height: "12px" }}><polyline points="20 6 9 17 4 12" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>}</div>
            <div className="cit"><h4>{t}</h4><p>{d}</p></div>
          </div>
        ))}
      </div>
      {done && <div style={{ marginTop: "14px", textAlign: "center" }}><div style={{ fontSize: "2.5rem", marginBottom: "8px" }}>🌟</div><h3 style={{ color: "var(--green)", fontSize: "1.1rem", marginBottom: "6px" }}>You're Cyber-Aware!</h3><p style={{ fontSize: ".88rem" }}>Thank you for your commitment. <span className="hl">You are the strongest link</span> — not the weakest.</p></div>}
    </div>
  );
}

function S16({ onComplete }) {
  const [cur, setCur] = useState(0);
  const [sel, setSel] = useState(null);
  const [answered, setAnswered] = useState(Array(14).fill(false));
  const [score, setScore] = useState(0);
  const [submitted, setSubmitted] = useState(false);

  function submit() {
    if (!sel || answered[cur]) return;
    const ok = sel === QUIZ_ANS[cur];
    const na = [...answered]; na[cur] = true; setAnswered(na);
    setSubmitted(true);
    const ns = ok ? score + 1 : score;
    if (ok) setScore(s => s + 1);
    if (cur === 13) { setTimeout(() => onComplete(ns), 0); }
  }

  function next() {
    setCur(c => c + 1); setSel(null); setSubmitted(false);
  }

  const q = QUIZ_QS[cur];
  const isOk = sel === QUIZ_ANS[cur];

  return (
    <div className="sec">
      <div className="snum" style={{ margin: "0 auto 12px" }}>Q</div>
      <h2 style={{ textAlign: "center" }}>Final Quiz — 14 Scenario Questions</h2>
      <p className="lead" style={{ textAlign: "center", margin: "0 auto 20px" }}>Each question presents a <span className="hl">real-world scenario</span>. You need <strong style={{ color: "#fff" }}>10 out of 14</strong> to pass.</p>
      <div className="qw">
        <div className="qq">
          <span className="qn">Question {cur + 1} of 14</span>
          <div className="qsc">{q.sc}</div>
          <h3>{q.q}</h3>
          <div className="qo">
            {q.opts.map(o => {
              let c = "qopt";
              if (submitted) { c += " dis"; if (o.a === QUIZ_ANS[cur]) c += " cor"; else if (o.a === sel) c += " wrg"; }
              else if (o.a === sel) c += " sel";
              return <div key={o.a} className={c} onClick={() => !submitted && setSel(o.a)}>{o.t}</div>;
            })}
          </div>
          {submitted && <div className={`qfb ${isOk ? "ok" : "no"}`}>{isOk ? `✅ Correct! +4 pts — ` : "❌ Incorrect. "}{QUIZ_EXP[cur]}</div>}
          <div className="qnav">
            {!submitted && <button className="btn p" disabled={!sel} onClick={submit}>Submit Answer</button>}
            {submitted && cur < 13 && <button className="btn p" onClick={next}>Next →</button>}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Main App ───────────────────────────────────────────────────────── */
export default function PhishingTraining() {
  const [page, setPage] = useState("signup"); // signup | training | cert | adminLogin | adminDash
  const [user, setUser] = useState({ name: "", empid: "", email: "", dept: "", startTime: null });
  const [curSec, setCurSec] = useState(0);
  const [points, setPoints] = useState(0);
  const [quizScore, setQuizScore] = useState(0);
  const [certTs, setCertTs] = useState("");
  const [copyMsg, setCopyMsg] = useState(false);
  const [formData, setFormData] = useState({ name: "", empid: "", email: "", dept: "" });
  const [formErrs, setFormErrs] = useState({});
  // Admin
  const [adminUser, setAdminUser] = useState("");
  const [adminPass, setAdminPass] = useState("");
  const [adminErr, setAdminErr] = useState(false);
  const [records, setRecords] = useState([]);
  const [changePw, setChangePw] = useState(false);
  const [newU, setNewU] = useState(""); const [newP, setNewP] = useState(""); const [newP2, setNewP2] = useState("");
  const [credOk, setCredOk] = useState(false);
  const adminCreds = useRef(ADMIN_CREDS);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash === "#admin") setPage("adminLogin");
  }, []);

  useEffect(() => {
    function onKey(e) {
      if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT") return;
      if (page !== "training") return;
      if (e.key === "ArrowRight" && curSec < 16) setCurSec(c => c + 1);
      if (e.key === "ArrowLeft" && curSec > 0) setCurSec(c => c - 1);
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [page, curSec]);

  function addPts(n) { setPoints(p => p + n); }

  function handleSignup(e) {
    e.preventDefault();
    const errs = {};
    if (!formData.name.trim()) errs.name = "Please enter your full name";
    if (!formData.empid.trim()) errs.empid = "Please enter your employee ID";
    if (!formData.email.trim() || !formData.email.includes("@")) errs.email = "Please enter a valid email";
    if (!formData.dept) errs.dept = "Please select your department";
    setFormErrs(errs);
    if (Object.keys(errs).length) return;
    setUser({ ...formData, startTime: new Date().toISOString() });
    setPage("training"); setCurSec(0); window.scrollTo(0, 0);
  }

  function onQuizComplete(score) {
    const finalPts = points + score * 4;
    setPoints(finalPts);
    setQuizScore(score);
    setCertTs(new Date().toLocaleString("en-IN", { dateStyle: "long", timeStyle: "short" }));
    const rec = {
      name: user.name, empid: user.empid, email: user.email, dept: user.dept,
      quizScore: score, totalPoints: finalPts, passed: score >= 10,
      startTime: user.startTime, completedAt: new Date().toISOString()
    };
    setRecords(prev => [...prev, rec]);
    setPage("cert"); window.scrollTo(0, 0);
  }

  function retake() {
    setPoints(p => Math.max(0, p - quizScore * 4));
    setQuizScore(0);
    setPage("training"); setCurSec(16);
  }

  function copyResults() {
    const passed = quizScore >= 10;
    const txt = `PHISHING TRAINING RESULT\n${"=".repeat(30)}\nName: ${user.name}\nEmployee ID: ${user.empid}\nEmail: ${user.email}\nDepartment: ${user.dept}\nQuiz Score: ${quizScore}/14 (${passed ? "PASSED" : "FAILED"})\nTotal Points: ${points}\nDate: ${new Date().toLocaleString("en-IN")}\n${"=".repeat(30)}`;
    navigator.clipboard.writeText(txt).then(() => { setCopyMsg(true); setTimeout(() => setCopyMsg(false), 2500); });
  }

  function downloadCSV() {
    if (!records.length) { alert("No training records found."); return; }
    const hdr = ["Name", "Employee ID", "Email", "Department", "Quiz Score", "Total Points", "Result", "Start Time", "Completed At"];
    const rows = [hdr.join(","), ...records.map(r => [r.name, r.empid, r.email, r.dept, `${r.quizScore}/14`, r.totalPoints, r.passed ? "PASSED" : "FAILED", r.startTime || "", r.completedAt || ""].map(v => `"${v}"`).join(","))];
    const a = document.createElement("a"); a.href = "data:text/csv;charset=utf-8," + encodeURIComponent(rows.join("\n")); a.download = "phishing_training_report.csv"; a.click();
  }

  function doAdminLogin() {
    const c = adminCreds.current;
    if (adminUser === c.user && adminPass === c.pass) {
      setAdminErr(false); setAdminUser(""); setAdminPass(""); setPage("adminDash");
    } else setAdminErr(true);
  }

  function doChangePw() {
    if (!newU || !newP) { alert("Fields cannot be empty."); return; }
    if (newP !== newP2) { alert("Passwords do not match."); return; }
    if (newP.length < 6) { alert("Password must be at least 6 characters."); return; }
    adminCreds.current = { user: newU, pass: newP };
    setNewU(""); setNewP(""); setNewP2(""); setCredOk(true); setTimeout(() => setCredOk(false), 3000);
  }

  const pct = Math.round((curSec / 16) * 100);
  const passed = quizScore >= 10;

  /* ── SIGNUP ── */
  if (page === "signup") return (
    <>
      <style>{CSS}</style>
      <div className="mesh" />
      <div className="sp">
        <div className="sc">
          <div className="logo">FYERS<span>.</span></div>
          <h1>Phishing Awareness Training</h1>
          <p className="sub">Mandatory Cybersecurity Awareness Program<br />Complete all sections, exercises, and quiz to earn your certificate.</p>
          <form onSubmit={handleSignup} noValidate>
            <div className="fg"><label>Full Name</label><input type="text" placeholder="e.g. Priya Sharma" value={formData.name} onChange={e => setFormData(f => ({ ...f, name: e.target.value }))} />{formErrs.name && <div className="ferr">{formErrs.name}</div>}</div>
            <div className="fg"><label>Employee ID</label><input type="text" placeholder="e.g. FYR-12345" value={formData.empid} onChange={e => setFormData(f => ({ ...f, empid: e.target.value }))} />{formErrs.empid && <div className="ferr">{formErrs.empid}</div>}</div>
            <div className="fg"><label>Email Address</label><input type="email" placeholder="e.g. priya.sharma@fyers.in" value={formData.email} onChange={e => setFormData(f => ({ ...f, email: e.target.value }))} />{formErrs.email && <div className="ferr">{formErrs.email}</div>}</div>
            <div className="fg">
              <label>Department</label>
              <select value={formData.dept} onChange={e => setFormData(f => ({ ...f, dept: e.target.value }))}>
                <option value="">Select your department</option>
                {["Technology", "Product", "Customer Support", "Risk & Compliance", "Operations", "HR & Admin", "Finance & Accounts", "Legal & Regulatory", "Marketing", "Sales & Partnerships", "Data & Analytics", "Leadership", "Other"].map(d => <option key={d} value={d}>{d}</option>)}
              </select>
              {formErrs.dept && <div className="ferr">{formErrs.dept}</div>}
            </div>
            <button type="submit" className="sbtn">Begin Training →</button>
          </form>
          <div className="sinfo">
            <div><div className="sin">~25 min</div><div className="sil">Training</div></div>
            <div><div className="sin">8+</div><div className="sil">Exercises</div></div>
            <div><div className="sin">14</div><div className="sil">Quiz Qs</div></div>
            <div><div className="sin">✓</div><div className="sil">Certificate</div></div>
          </div>
        </div>
      </div>
    </>
  );

  /* ── TRAINING ── */
  if (page === "training") return (
    <>
      <style>{CSS}</style>
      <div className="mesh" />
      <div className="tp">
        <div className="tbar">
          <div className="sl">{SEC_NAMES[curSec]}</div>
          <div className="pt"><div className="pf" style={{ width: `${pct}%` }} /></div>
          <div className="pb">⭐ {points} pts</div>
        </div>
        <div key={curSec}>
          {curSec === 0 && <S0 name={user.name.split(" ")[0]} />}
          {curSec === 1 && <S1 addPts={addPts} />}
          {curSec === 2 && <S2 addPts={addPts} />}
          {curSec === 3 && <S3 addPts={addPts} />}
          {curSec === 4 && <S4 addPts={addPts} />}
          {curSec === 5 && <S5 />}
          {curSec === 6 && <S6 addPts={addPts} />}
          {curSec === 7 && <S7 addPts={addPts} />}
          {curSec === 8 && <S8 addPts={addPts} />}
          {curSec === 9 && <S9 addPts={addPts} />}
          {curSec === 10 && <S10 />}
          {curSec === 11 && <S11 addPts={addPts} />}
          {curSec === 12 && <S12 />}
          {curSec === 13 && <S13 addPts={addPts} />}
          {curSec === 14 && <S14 />}
          {curSec === 15 && <S15 addPts={addPts} />}
          {curSec === 16 && <S16 onComplete={onQuizComplete} />}
        </div>
        <div className="bn">
          <button className="btn g" onClick={() => curSec > 0 && setCurSec(c => c - 1)} style={{ visibility: curSec > 0 ? "visible" : "hidden" }}>← Previous</button>
          <div className="bi">Section {curSec + 1} of 17</div>
          {curSec < 16 ? <button className="btn p" onClick={() => setCurSec(c => c + 1)}>Next Section →</button> : <div />}
        </div>
      </div>
    </>
  );

  /* ── CERTIFICATE ── */
  if (page === "cert") return (
    <>
      <style>{CSS}</style>
      <div className="mesh" />
      <div className="certp">
        <div className="certc">
          <div className="certb">{passed ? "🏆" : "📚"}</div>
          <h2>Training Complete</h2>
          <div className="certn">{user.name}</div>
          <div className="certd">{user.dept} | {user.empid}</div>
          <div className="certst">
            <div><div className="certsn" style={{ color: "#2962FF" }}>{quizScore}/14</div><div className="certsl">Quiz Score</div></div>
            <div><div className="certsn" style={{ color: "#22c55e" }}>{points}</div><div className="certsl">Total Points</div></div>
            <div><div className="certsn" style={{ color: "#ef4444" }}>{14 - quizScore}</div><div className="certsl">Wrong</div></div>
          </div>
          <p style={{ fontSize: ".95rem", fontWeight: "600", margin: "12px 0 4px", color: passed ? "var(--green)" : "var(--red)" }}>{passed ? "PASSED" : "NOT PASSED — 10/14 Required"}</p>
          <p style={{ fontSize: ".82rem", color: "var(--muted)", lineHeight: "1.5" }}>{passed ? "Congratulations! You have demonstrated strong phishing awareness. Share this knowledge with your team." : "Please review the training material and retake the quiz. You can do it!"}</p>
          <div className="certa">
            <button className="btn p" onClick={copyResults}>📋 Copy Results</button>
            <button className="btn s" onClick={() => window.print()}>🖨️ Print</button>
            <button className="btn s" onClick={downloadCSV}>📥 Download CSV</button>
            <button className="btn g" onClick={retake}>🔄 Retake</button>
          </div>
          {copyMsg && <div style={{ fontSize: ".78rem", color: "var(--green)", marginTop: "8px" }}>Results copied to clipboard!</div>}
          <div className="certts">Completed: {certTs}</div>
        </div>
      </div>
    </>
  );

  /* ── ADMIN LOGIN ── */
  if (page === "adminLogin") return (
    <>
      <style>{CSS}</style>
      <div className="mesh" />
      <div className="sp">
        <div className="sc" style={{ maxWidth: "420px" }}>
          <div className="logo">FYERS<span>.</span></div>
          <h1 style={{ fontSize: "1.4rem", marginBottom: "2px" }}>Admin Dashboard</h1>
          <p className="sub" style={{ marginBottom: "22px" }}>Sign in to view participant results.</p>
          <div className="fg"><label>Username</label><input type="text" value={adminUser} onChange={e => setAdminUser(e.target.value)} placeholder="Enter admin username" autoComplete="off" /></div>
          <div className="fg"><label>Password</label><input type="password" value={adminPass} onChange={e => setAdminPass(e.target.value)} placeholder="Enter admin password" autoComplete="off" onKeyDown={e => e.key === "Enter" && doAdminLogin()} /></div>
          {adminErr && <div style={{ color: "var(--red)", fontSize: ".78rem", marginBottom: "10px" }}>Invalid username or password.</div>}
          <button className="sbtn" onClick={doAdminLogin}>Sign In</button>
          <div style={{ textAlign: "center", marginTop: "16px" }}><button style={{ background: "none", border: "none", cursor: "pointer", fontSize: ".78rem", color: "var(--muted)" }} onClick={() => setPage("signup")}>← Back to Training</button></div>
        </div>
      </div>
    </>
  );

  /* ── ADMIN DASHBOARD ── */
  if (page === "adminDash") {
    const passed2 = records.filter(r => r.passed).length;
    const avg = records.length ? (records.reduce((a, r) => a + (r.quizScore || 0), 0) / records.length).toFixed(1) : 0;
    return (
      <>
        <style>{CSS}</style>
        <div className="mesh" />
        <div className="adp">
          <div style={{ maxWidth: "960px", width: "100%", margin: "0 auto", padding: "40px 24px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
              <div>
                <div className="logo" style={{ textAlign: "left", marginBottom: "4px" }}>FYERS<span>.</span></div>
                <h2 style={{ color: "#fff", fontSize: "1.3rem", fontWeight: "600" }}>Training Admin Dashboard</h2>
                <p style={{ color: "var(--muted)", fontSize: ".82rem" }}>View and download all participant results</p>
              </div>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                <button className="btn p" onClick={downloadCSV} style={{ fontSize: ".8rem", padding: "8px 16px" }}>Download CSV</button>
                {/* <button className="btn g" onClick={() => { if (confirm("Delete ALL records?")) setRecords([]) }} style={{ fontSize: ".8rem", padding: "8px 16px", color: "var(--red)", borderColor: "rgba(239,68,68,.2)" }}>Clear All</button> */}
                <button className="btn g" onClick={() => setPage("adminLogin")} style={{ fontSize: ".8rem", padding: "8px 16px" }}>Logout</button>
              </div>
            </div>
            {records.length > 0 && (
              <div className="sr" style={{ marginBottom: "20px" }}>
                <div className="sb"><div className="sbn">{records.length}</div><div className="sbl">Total<br />Participants</div></div>
                <div className="sb"><div className="sbn" style={{ color: "var(--green)" }}>{passed2}</div><div className="sbl">Passed</div></div>
                <div className="sb"><div className="sbn" style={{ color: "var(--red)" }}>{records.length - passed2}</div><div className="sbl">Failed</div></div>
                <div className="sb"><div className="sbn">{Math.round(passed2 / records.length * 100)}%</div><div className="sbl">Pass Rate</div></div>
                <div className="sb"><div className="sbn">{avg}</div><div className="sbl">Avg Quiz<br />Score</div></div>
              </div>
            )}
            <div style={{ overflowX: "auto", borderRadius: "var(--r)", border: "1px solid rgba(255,255,255,.05)" }}>
              {records.length === 0 ? (
                <div style={{ textAlign: "center", padding: "60px 20px", color: "var(--muted)" }}>
                  <div style={{ fontSize: "2rem", marginBottom: "8px", opacity: ".4" }}>—</div>
                  <p>No training records yet.</p>
                  <p style={{ fontSize: ".78rem", marginTop: "4px" }}>Records appear here after participants complete the training.</p>
                </div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: ".8rem" }}>
                  <thead>
                    <tr style={{ background: "rgba(255,255,255,.03)", textAlign: "left" }}>
                      {["#", "Name", "Employee ID", "Email", "Department", "Quiz", "Points", "Result", "Completed"].map(h => (
                        <th key={h} style={{ padding: "10px 14px", color: "var(--muted)", fontWeight: "600", fontSize: ".7rem", textTransform: "uppercase", letterSpacing: ".5px", whiteSpace: "nowrap" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((r, i) => (
                      <tr key={i}>
                        <td style={{ padding: "10px 14px", color: "var(--dim)", borderTop: "1px solid rgba(255,255,255,.03)" }}>{i + 1}</td>
                        <td style={{ padding: "10px 14px", color: "#fff", fontWeight: "500", borderTop: "1px solid rgba(255,255,255,.03)" }}>{r.name || "—"}</td>
                        <td style={{ padding: "10px 14px", borderTop: "1px solid rgba(255,255,255,.03)" }}>{r.empid || "—"}</td>
                        <td style={{ padding: "10px 14px", borderTop: "1px solid rgba(255,255,255,.03)" }}>{r.email || "—"}</td>
                        <td style={{ padding: "10px 14px", borderTop: "1px solid rgba(255,255,255,.03)" }}>{r.dept || "—"}</td>
                        <td style={{ padding: "10px 14px", borderTop: "1px solid rgba(255,255,255,.03)" }}>{r.quizScore || 0}/14</td>
                        <td style={{ padding: "10px 14px", borderTop: "1px solid rgba(255,255,255,.03)" }}>{r.totalPoints || 0}</td>
                        <td style={{ padding: "10px 14px", borderTop: "1px solid rgba(255,255,255,.03)" }}><span className={r.passed ? "adpass" : "adfail"}>{r.passed ? "PASSED" : "FAILED"}</span></td>
                        <td style={{ padding: "10px 14px", color: "var(--muted)", borderTop: "1px solid rgba(255,255,255,.03)" }}>{r.completedAt ? new Date(r.completedAt).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div style={{ marginTop: "24px", paddingTop: "16px", borderTop: "1px solid rgba(255,255,255,.05)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
              <p style={{ fontSize: ".72rem", color: "var(--dim)" }}>Data stored in session memory. Download CSV before closing.</p>
              <button className="btn g" onClick={() => setChangePw(v => !v)} style={{ fontSize: ".75rem", padding: "6px 12px" }}>Change Password</button>
            </div>
            {changePw && (
              <div style={{ marginTop: "14px", background: "var(--bg2)", border: "1px solid rgba(255,255,255,.05)", borderRadius: "var(--r)", padding: "20px" }}>
                <h3 style={{ color: "#fff", fontSize: ".9rem", marginBottom: "12px" }}>Change Admin Credentials</h3>
                <div className="fg" style={{ maxWidth: "300px" }}><label>New Username</label><input type="text" value={newU} onChange={e => setNewU(e.target.value)} placeholder="Enter new username" /></div>
                <div className="fg" style={{ maxWidth: "300px" }}><label>New Password</label><input type="password" value={newP} onChange={e => setNewP(e.target.value)} placeholder="Enter new password" /></div>
                <div className="fg" style={{ maxWidth: "300px" }}><label>Confirm Password</label><input type="password" value={newP2} onChange={e => setNewP2(e.target.value)} placeholder="Confirm new password" /></div>
                <button className="btn p" onClick={doChangePw} style={{ fontSize: ".82rem", padding: "8px 20px" }}>Save Credentials</button>
                {credOk && <span style={{ marginLeft: "12px", fontSize: ".78rem", color: "var(--green)" }}>Credentials updated!</span>}
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  return null;
}
